import { render } from "./CreateOrganisationRole.vue?vue&type=template&id=0fbb7314"
import script from "./CreateOrganisationRole.vue?vue&type=script&lang=js"
export * from "./CreateOrganisationRole.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__